import { Alert, AlertTitle, Stack, Typography } from '@mui/material';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { ValidationResult } from '../utils/validation/validateSchema';

type ValidationAlertsProps = {
  result?: ValidationResult;
};

// Individual validation alerts for each item
export const ValidationAlerts = ({ result }: ValidationAlertsProps) => {
  const { t } = useTranslation();
  if (!result || result.valid) return null;

  const errorMessages = result.messages.filter((m) => m.severity === 'error');
  const warningMessages = result.messages.filter(
    (m) => m.severity === 'warning'
  );

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {errorMessages.length > 0 && (
        <Alert severity='error'>
          <AlertTitle>{t('Validation Errors')}</AlertTitle>
          {errorMessages.map((msg, idx) => (
            <Typography key={idx} variant='body2'>
              {msg.path !== 'summary' && <strong>{msg.path}: </strong>}
              {msg.message}
            </Typography>
          ))}
        </Alert>
      )}

      {warningMessages.length > 0 && (
        <Alert severity='warning'>
          <AlertTitle>{t('Warnings')}</AlertTitle>
          {warningMessages.map((msg, idx) => (
            <Typography key={idx} variant='body2'>
              {msg.path !== 'summary' && <strong>{msg.path}: </strong>}
              {msg.message}
            </Typography>
          ))}
        </Alert>
      )}
    </Stack>
  );
};
